import { Tag } from 'antd';
import { FC, memo } from 'react';

import { Domain, DomainConfigurationStatus } from '@/modules/Domains';

type Props = Pick<Domain, 'configurationStatus' | 'isConfigured'>;

export const DomainConfigurationStatusTag: FC<Props> = memo(({ configurationStatus: status, isConfigured }) => {
  if (status === DomainConfigurationStatus.NotConfigured) return <Tag color="default">Не налаштований</Tag>;

  if (status === DomainConfigurationStatus.Configured) return <Tag color="success">Налаштований</Tag>;

  if (status === DomainConfigurationStatus.Attaching) return <Tag color="blue">Налаштування</Tag>;

  if (status === DomainConfigurationStatus.Detaching) return <Tag color="geekblue">Скидання</Tag>;

  if (status === DomainConfigurationStatus.Failed) return <Tag color="error">Помилка</Tag>;

  if (status === DomainConfigurationStatus.Pending) return (
    <Tag color="orange">{ `В черзі на ${ isConfigured ? 'скидання' : 'налаштування' }` }</Tag>
  );
});
